import React from 'react';
import ReactTooltip from 'react-tooltip';

import Auxiliary from '../../hoc/Auxiliary/Auxiliary';

import './ComparisonView.css';

const comparisonView = (props) => {
    //console.log(props.data);

    const onClicked = (e) => {
        const id = e.currentTarget.getAttribute('data-value');

        props.onClicked(id);
    } 

    const items = props.data[0].map((i, k) => {
        const nps = props.data[1][k];
        const happy = props.data[2][k];
        const neutral = props.data[3][k];
        const sad = props.data[4][k];

        const npsStyle = {
            position: 'relative',
            height: 'calc(50% - 4px)',
            width: 'calc(' + nps + '% - 4px)',
            backgroundColor: 'blue',
            margin: '2px',
            borderRadius: '5px'
        };
        const happyStyle = {
            position: 'relative',
            width: happy + '%',
            height: 'calc(100% - 4px)',
            backgroundColor: '#47b749',
            borderTopLeftRadius: '5px',
            borderBottomLeftRadius: '5px'
        };
        const neutraStyle = {
            position: 'relative',
            width: neutral + '%',
            height: 'calc(100% - 4px)',
            backgroundColor: '#f5ee34'
        }
        const sadStyle = {
            position: 'relative',
            width: sad + '%',
            height: 'calc(100% - 4px)',
            backgroundColor: '#ee2930',
            borderTopRightRadius: '5px',
            borderBottomRightRadius: '5px'
        }
        
        return (
            <div key={k} className="ComparisonViewItem">
                <div className="ComparisonViewItemHeader" data-value={k} onClick={onClicked}>
                    <span>{i}</span>
                </div>
                <div className="ComparisonViewItemBody">
                    <div style={npsStyle} data-for={'nps-' + k} 
                        data-tip={nps !== undefined ? 'NPS = ' + nps.toFixed(1) + '%' : 'No NPS Data'}></div>
                    <ReactTooltip id={'nps-' + k} place='top' type='dark' effect='float'/>
                    <div className="ComparisonViewItemBodyPushes">
                        <div style={happyStyle} data-for={'happy-' + k} 
                        data-tip={happy !== undefined ? happy.toFixed(1) + '% happy responses' : 'No Response Data'}></div>
                        <ReactTooltip id={'happy-' + k} place='top' type='dark' effect='float'/>
                        <div style={neutraStyle} data-for={'neutral-' + k} 
                        data-tip={neutral !== undefined ? neutral.toFixed(1) + '% neutral responses' : 'No Response Data'}></div>
                        <ReactTooltip id={'neutral-' + k} place='top' type='dark' effect='float'/>
                        <div style={sadStyle} data-for={'sad-' + k} 
                        data-tip={sad !== undefined ? sad.toFixed(1) + '% sad responses' : 'No Response Data'}></div>
                        <ReactTooltip id={'sad-' + k} place='top' type='dark' effect='float'/>
                    </div>
                </div>
            </div>
        );
    });

    return (
        <Auxiliary>
            <div className="ComparisonViewHeader"><span>{props.title}</span></div>
            <div className="ComparisonViewBody">
                {items}
            </div>
        </Auxiliary>
    );
};

export default comparisonView;